<template>
  <dg-field-container :field_mark="field_mark" :field_span="field_span" :label_span="label_span"
                      style="min-height: 200px">
    <template v-slot:label>
      {{ label }}
    </template>
    <template v-slot:field>
      <el-upload
          :auto-upload="autoUpload"
          :before-upload="beforeUpload"
          :file-list="filesList"
          :on-change="onChange"
          :on-preview="handlePictureCardPreview"
          action="autoUploadPath"
          list-type="picture-card"
          multiple
          ref="attachmentUploader">
        <i class="el-icon-plus" slot="default"></i>
        <div slot="file" slot-scope="{file}">
          <img :src="getFileThumbnail(file)"
               alt="" class="el-upload-list__item-thumbnail">
          <div class="filename">{{ fileName }}</div>
          <span class="el-upload-list__item-actions">
              <span @click="handlePictureCardPreview(file)" class="el-upload-list__item-preview mr-2" v-if="viewEvent">
                  <i class="el-icon-zoom-in"></i>
              </span>
              <span @click="handleDownload(file)" class="el-upload-list__item-delete mr-2" v-if="downloadEvent">
                <i class="el-icon-download"></i>
              </span>
              <span @click="handleRemove(file)" class="el-upload-list__item-delete mr-2"
                    v-if="!featureDisabled">
                <i class="el-icon-delete"></i>
              </span>
          </span>
        </div>
      </el-upload>
      <slot name="field_note"></slot>
      <div class="error-field-validate-message" v-if="validateMessage">
        {{ validateMessage }}
      </div>
    </template>
  </dg-field-container>
</template>

<script>
import inputField from '../mixins/inputField';

export default {
  mixins: [inputField],
  props: {
    viewEvent: {
      required: false,
      default: false
    },
    downloadEvent: {
      required: false,
      default: false
    },
    autoUpload: {
      required: false,
      default: false
    },
    removeFileFromBackend: {
      required: true
    },
    autoUploadPath: {
      required: false,
      default: ''
    },
    label: {
      required: true,
      type: String
    },
    fileSizeLimit: {
      required: false,
      default: 2
    },
    allowedExt: {
      required: false,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      featureDisabled: false,
      fileName: '',
      field_value: null,
      filesList: [],
      binding: 'files-list',
      extAndIcons: {
        'pdf': 'file',
        'xls': 'file',
        'xlsx': 'file',
        'mp3': 'file',
        'mp4': 'file',
      }
    };
  },
  methods: {
    getFileThumbnail(file) {
      let type = null
      if (file.hasOwnProperty('raw')) {
        type = file.raw.type
      } else {
        type = file.type
      }

      if (this.fileIsImage(type)) {
        return file.url
      }

      return this.getThumbnail(file.name.split('.')[1]);
    },
    getThumbnail (ext) {
      if (this.extAndIcons.hasOwnProperty(ext)) return '/img/files/' + this.extAndIcons[ext] + '.png'
      return '/img/files/file.png'
    },
    fileIsImage(type) {
      return ['image/jpeg', 'image/jpg', 'image/png'].indexOf(type) !== -1;
    },
    beforeUpload(file) {
      if (this.autoUpload && this.autoUploadPath == '') {
        this.$message.error('No Auto Upload Path Defined');
        return false;
      }
      let fileExt = file.name.split('.');
      if (fileExt.length > 1) {
        fileExt = fileExt[fileExt.length - 1];
      } else {
        fileExt = ''
      }
      let allowedExt = this.allowedExt;
      const validExt = allowedExt.indexOf(fileExt) !== -1;
      const maxMBSize = file.size / 1024 / 1024 <= this.fileSizeLimit; // 2MB max file size

      if (!validExt) {
        this.$message.error('file picture must be from these formats: ' + allowedExt);
      }
      if (!maxMBSize) {
        this.$message.error(this.$ml.get('file_cant_exceed_size') + this.fileSizeLimit + 'MB');
      }
      let r = validExt && maxMBSize;

      if (!r) this.handleRemove(file)
      return r;
    },
    onChange(file) {
      if (!this.beforeUpload(file.raw)) return
      this.fileName = file.name;
      this.imageUrl = this.getFileThumbnail(file);
      let inputFiles = this.$refs.attachmentUploader.uploadFiles
      let files = []
      for (let f in inputFiles) {
        files.push(inputFiles[f].raw)
      }
      this.field_value = files
      this.updateValue();
    },
    handleRemove(file, index) {
      let files = this.$refs.attachmentUploader.uploadFiles;
      let filesCount = files.length;
      for (let i = 0; i < filesCount; i++) {
        if (file.uid === files[i].uid) {
          files.splice(i, 1)
          break
        }
      }
      if (file.hasOwnProperty('id')) {
        this.removeFileFromBackend(file)
      }
    },
    prepareForEvent(file) {
      let ext = file.type.split('/')[1]
      return {
        url: file.url,
        name: file.name,
        extension: ext,
        isImage: this.isExtenionForImage(ext)
      }
    },
    handleDownload(file) {
      this.downloadEvent(this.prepareForEvent(file))
    },
    handlePictureCardPreview(file) {
      this.viewEvent(this.prepareForEvent(file))
    },
    isExtenionForImage (ext) {
      return ['jpeg', 'jpg', 'png', 'svg'].indexOf(ext) !== -1;
    },
  }
}
</script>

<style lang="scss">
.el-upload-list__item {
  .filename {
    position: absolute;
    left: 0;
    top: 0;
    background-color: rgba(40, 40, 40, .8);
    color: #fff;
    height: 100%;
    width: 100%;
    text-align: center;
    font-size: 14px;
    padding-top: 20px;
  }
}
</style>
